export default __webpack_public_path__ + "static/media/04en.c80e715d.mp3";